import { OwnAccountsTransfer } from "@/modules/transaction/components";
import type { IOperationPageProps } from "@/shared/common/types";

export const OwnAccountsTransferPage = ({ isCopy, isEdit }: IOperationPageProps) => (
  <OwnAccountsTransfer isCopy={isCopy} isEdit={isEdit}/>
);
